/** Temporary and permanent numbers (2026-11-09): a student keeps a
 * TEMP-STU / TEMP-APP reference until registered with an approved
 * Registration Fee, and a payment keeps a TEMP-PAY reference until approved.
 * The permanent number replaces it; the temporary one is kept as history. */
export type NumberKind = 'student' | 'application' | 'payment';

export const isTemporaryNumber = (value: string | null | undefined) => !!value?.startsWith('TEMP-');

export const TEMPORARY_LABEL: Record<NumberKind, string> = {
  student: 'Temporary Student Number',
  application: 'Temporary Application Number',
  payment: 'Temporary Payment Reference',
};

export const TEMPORARY_HINT: Record<NumberKind, string> = {
  student:
    'The permanent student number is issued once the student is registered and the Registration Fee is approved.',
  application:
    'The permanent application number is issued with the permanent student number, once the Registration Fee is approved.',
  payment: 'The permanent payment number is issued when Finance approves the payment.',
};

/** "TEMP-STU000012 (Temporary Student Number)" — plain text for messages and titles. */
export const describeNumber = (value: string | null | undefined, kind: NumberKind) =>
  value ? (isTemporaryNumber(value) ? `${value} (${TEMPORARY_LABEL[kind]})` : value) : '';
